import { makeAutoObservable } from "mobx";

export class LogisticBackdropStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  showLoading = false;
  
  openLoading(){
    this.showLoading = true
  }

  closeLoading(){
    this.showLoading = false
  }
}
